import {Exclude, Expose, instanceToPlain, plainToInstance} from "class-transformer";
import * as t from "io-ts";
import {validateJSON} from "../web/validation";
import {DecisionGraphData, DecisionGraphValidator} from "./decision-graph";

export const ContainerTotalFillValidator = t.intersection([
  t.type({}),
  t.partial({
    dttm: t.number,
    rate: t.number,
    actualPercent: t.number,
    actualHeight: t.number,
    actualVolume: t.number,
    actualStatus: t.string,
    actualTimeToFull: t.number,
    actualTimeToFullCritical: t.boolean,
    actualPotentialShutIn: t.boolean,
    estimatedPercent: t.number,
    estimatedHeight: t.number,
    estimatedVolume: t.number,
    estimatedStatus: t.string,
    estimatedTimeToFull: t.number,
    estimatedTimeToFullCritical: t.boolean,
    estimatedPotentialShutIn: t.boolean,
    availableLoadCount: t.number,
    potentialAvailableLoadCount: t.number,
    availableLoadVolume: t.number,
    dayOfEstimatedLoadCount: t.number,
    nextDayEstimatedLoadCount: t.number,
    exceedsMaxNonPrimaryVolume: t.boolean,
    availableLoadDecisionGraph: DecisionGraphValidator,
  }),
]);

export const ContainerTotalFillArrayValidator = t.array(ContainerTotalFillValidator);

export type ContainerTotalFill = t.TypeOf<typeof ContainerTotalFillValidator>;
export type ContainerTotalFillArray = t.TypeOf<typeof ContainerTotalFillArrayValidator>;


@Exclude()
export class ContainerTotalFillEntity {
  @Expose() dttm?: number
  @Expose() rate?: number
  @Expose() actualPercent?: number
  @Expose() actualHeight?: number
  @Expose() actualVolume?: number
  @Expose() actualStatus?: string
  @Expose() actualTimeToFull?: number
  @Expose() actualTimeToFullCritical?: boolean
  @Expose() actualPotentialShutIn?: boolean
  @Expose() estimatedPercent?: number
  @Expose() estimatedHeight?: number
  @Expose() estimatedVolume?: number
  @Expose() estimatedStatus?: string
  @Expose() estimatedTimeToFull?: number
  @Expose() estimatedTimeToFullCritical?: boolean
  @Expose() estimatedPotentialShutIn?: boolean
  @Expose() availableLoadCount?: number
  @Expose() potentialAvailableLoadCount?: number
  @Expose() availableLoadVolume?: number
  @Expose() dayOfEstimatedLoadCount?: number
  @Expose() nextDayEstimatedLoadCount?: number
  @Expose() exceedsMaxNonPrimaryVolume?: boolean
  /** How the available loads were calculated, as a decision flow. */
  @Expose() availableLoadDecisionGraph?: DecisionGraphData

  /**
   * Constructor for ContainerFillEntity.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(containerTotalFill: ContainerTotalFill): ContainerTotalFillEntity {
    return plainToInstance(
      ContainerTotalFillEntity,
      containerTotalFill,
      {
        excludeExtraneousValues: true,
      }
    );
  }

  toTypeValue(): Promise<ContainerTotalFill> {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSON(ContainerTotalFillValidator, object);
  }
}
